import React, { useEffect, useState } from 'react';
import { HOW_TO_STEPS, HOW_TO_STORAGE_KEY } from '../../game/presentation';

interface HowToProps {
  open?: boolean;
  onClose?: () => void;
  auto?: boolean;
}

function hasSeenHowTo(): boolean {
  try {
    return window.localStorage.getItem(HOW_TO_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function markHowToSeen() {
  try {
    window.localStorage.setItem(HOW_TO_STORAGE_KEY, '1');
  } catch {
    // ignore
  }
}

const HowTo: React.FC<HowToProps> = ({ open, onClose, auto = false }) => {
  const [visible, setVisible] = useState(() => Boolean(open) || (auto && !hasSeenHowTo()));

  useEffect(() => {
    if (open) {
      setVisible(true);
    }
  }, [open]);

  const close = () => {
    markHowToSeen();
    setVisible(false);
    onClose?.();
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="ss-overlay is-center" role="dialog" aria-modal="true" aria-labelledby="howto-title">
      <div className="ss-modal ss-howto">
        <h2 id="howto-title">How to play</h2>
        <p className="ss-sub" style={{ textAlign: 'left', marginTop: 0 }}>
          60 seconds. Then you are ready.
        </p>
        <ol>
          {HOW_TO_STEPS.map((step) => (
            <li key={step.title}>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </li>
          ))}
        </ol>
        <button type="button" className="ss-btn ss-btn-primary" onClick={close} autoFocus>
          Let’s play
        </button>
      </div>
    </div>
  );
};

export default HowTo;
